import { Questionario } from 'unb-questionario-componente';

export class Estudo {
    public id: number;
    public aluno: number;
    public periodo: number;
    public situacao: number;
    public dataInclusao: Date;
    public respostaQuestionarioPreliminar: number;
    public respostaQuestionarioDadosPessoais: number;
    public respostaQuestionarioMoradia: number;
    public usuarioResponsavel: number;
    public usuarioNome: string;
    public observacao: string;

    // variaveis transient
    public situacaoDenominacao: string;
    public alunoNome: string;
    public alunoRa: string;
    public alunoNivel: number;
    public pontuacaoGeral: string;
    public pontuacaoMoradia: string;
    public aluCodigoCampus: number;
    public aluNomeCampus: string;

    public filtroAtribuidosAMim: boolean;
    public filtroNaoAtribuidos: boolean;
    public filtroMostrarSomenteMoradia: boolean;
    public filtroResponsavel: string;
    
    // mantém o questiorio montado na memória pra nao ser necessário carregar toda hora
    public questionarioPreliminar: Questionario;
    public questionarioDadosPessoais: Questionario;
    public questionarioGrupoFamiliar: Questionario;

}
